<script setup lang="ts">
import { PropType } from 'vue'

/* Components */
import ProductCardComponentsItem from '@/components/Product/ProductItem/ProductContent/ProductCardComponentsItem.vue'
import IconArrowRight from '@/components/Icons/IconArrowRight.vue'
import IconArrowLeft from '@/components/Icons/IconArrowLeft.vue'

/* Types */
import { Component } from '@/types/api/api-v3/product'

const props = defineProps({
  components: {
    type: Array as PropType<Component[]>,
    required: true,
  },
})
</script>

<template>
  <v-slide-group
    show-arrows
    :prev-icon="IconArrowLeft"
    :next-icon="IconArrowRight"
  >
    <v-slide-group-item
      v-for="component in props.components"
      :key="component.id"
      v-ripple
    >
      <product-card-components-item :component="component" />
    </v-slide-group-item>
  </v-slide-group>
</template>

<style lang="scss" scoped>
.v-slide-group {
  position: relative;
  display: flex;
  flex: 0 1 auto;
  max-width: 100%;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

:deep() {
  .v-slide-group__container {
    padding-bottom: 20px;

    @include media('<=desktop-mini') {
      padding: 24px 48px 20px 48px;
    }

    @include media('<=tablet') {
      padding: 24px 20px 26px 20px;
    }
  }

  .v-slide-group__prev,
  .v-slide-group__next {
    position: absolute;
    top: 0;
    z-index: 1;
    width: 30px;
    height: 100%;

    &--disabled {
      display: none;
    }

    .v-icon:before {
      color: $text-black;
    }
  }

  .v-slide-group__next {
    right: -10px;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0), white);
  }

  .v-slide-group__prev {
    left: -10px;
    background: linear-gradient(90deg, white, rgba(255, 255, 255, 0));
  }

  .v-slide-group__content {
    @include media('<desktop-mini') {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;
    }
    @include media('<tablet') {
      display: grid;
      grid-template-columns: 1fr;
      gap: 10px;
    }
  }
}
</style>
